import { BoxSlotTemplateEntity } from "@/modules/boxSlotTemplate/entities/boxSlotTemplateEntity"
import type { BoxSlotTemplateWeekDto } from "@/modules/boxSlotTemplate/gateway/boxSlotTemplateDto"

export class BoxSlotTemplateWeekEntity {
  private constructor(
    public readonly week: {
      MONDAY: BoxSlotTemplateEntity[]
      TUESDAY: BoxSlotTemplateEntity[]
      WEDNESDAY: BoxSlotTemplateEntity[]
      THURSDAY: BoxSlotTemplateEntity[]
      FRIDAY: BoxSlotTemplateEntity[]
      SATURDAY: BoxSlotTemplateEntity[]
      SUNDAY: BoxSlotTemplateEntity[]
    },
  ) {}

  static fromDto(dto: BoxSlotTemplateWeekDto): BoxSlotTemplateWeekEntity {
    return new BoxSlotTemplateWeekEntity({
      MONDAY: dto.week.MONDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
      TUESDAY: dto.week.TUESDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
      WEDNESDAY: dto.week.WEDNESDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
      THURSDAY: dto.week.THURSDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
      FRIDAY: dto.week.FRIDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
      SATURDAY: dto.week.SATURDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
      SUNDAY: dto.week.SUNDAY?.map((day) => BoxSlotTemplateEntity.fromDto(day)) ?? [],
    })
  }
}
